var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19934 1.78373C4.71551 2.75767 2.32816 3.8008 1.89398 4.10168C1.46001 4.40234 0.873915 5.05192 0.591445 5.54492L0.0781314 6.44121L0.0148658 24.2146C-0.0198346 33.99 0.00830771 42.383 0.077497 42.8657C0.260098 44.1382 1.25901 45.5203 2.4549 46.1546C3.00969 46.4489 5.39957 47.4345 7.76576 48.3447L12.0678 50L12.7918 49.61C13.2908 49.3413 13.6966 48.8521 14.0969 48.0373L14.6777 46.8545V24.9552V3.0558L14.2143 2.05223C13.6663 0.866071 12.7825 -0.017099 12.1607 0.00025125C11.9159 0.00702207 9.68317 0.809576 7.19934 1.78373ZM17.3226 4.96009V6.33541H22.1891H27.0556V11.9425V17.5496H28.4309H29.8063V10.5672V3.58477H23.5644H17.3226V4.96009ZM32.935 18.1941L32.8743 20.406H25.0984H17.3226V24.9023V29.3985H25.1439H32.9653L33.0256 31.5171L33.0859 33.6358L37.4763 29.2407L41.8668 24.8456L37.4313 20.4138L32.9957 15.9821L32.935 18.1941ZM11.5989 23.6344C12.2165 24.1346 12.2447 25.2607 11.6541 25.8512C10.6785 26.8267 9.07063 26.1227 9.07063 24.7201C9.07063 23.4685 10.589 22.8166 11.5989 23.6344ZM27.0556 37.8974V43.5749H22.1891H17.3226V44.9502V46.3256H23.5644H29.8063V39.3432V32.3607L28.907 32.3432C28.4123 32.3335 27.7936 32.3017 27.5317 32.2727L27.0556 32.2198V37.8974Z",
    fill: "#253d7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0360d205d6678f27ddba936edd8805aa.svg";
export { ForwardRef as ReactComponent };